<template>
  <div>
    <h3 class="text-subtitle-1 font-weight-bold mb-4 d-flex align-center ga-2">
      <v-icon
        size="18"
        color="primary"
      >
        mdi-connection
      </v-icon>
      {{ $t('onboarding.wizard.data-entry.connections') }}
    </h3>

    <p class="text-body-2 text-medium-emphasis mb-4">
      {{ $t('onboarding.wizard.data-entry.connections-hint') }}
    </p>

    <CrmConnectionsSegment class="onboarding-connection-segment mb-4" />
    <SocialMediaConnectionsSegment class="onboarding-connection-segment mb-6" />

    <v-divider class="mb-6" />
  </div>
</template>

<script setup lang="ts">
import CrmConnectionsSegment from '@/modules/connectionManager/CrmConnectionsSegment.vue'
import SocialMediaConnectionsSegment from '@/modules/connectionManager/SocialMediaConnectionsSegment.vue'
</script>

<style scoped>
/* Pack provider cards into a compact row (like the image tiles) instead of the
   fixed 250px cards, which stack into a long column in the narrow form. */
.onboarding-connection-segment :deep(.connection-segment__content) {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}

.onboarding-connection-segment :deep(.connection) {
  min-width: 0;
  max-width: none;
  width: 100%;
}

.onboarding-connection-segment :deep(.connection__content) {
  padding: 12px 8px;
  gap: 8px;
}

.onboarding-connection-segment :deep(.connection__image) {
  height: 44px !important;
  padding: 0 8px;
}

.onboarding-connection-segment :deep(.connection__image .v-img__img) {
  max-height: 44px !important;
}
</style>
